import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  const themeContext = useContext(ThemeContext);

  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 4L14 4"
        stroke={themeContext.colors.font1}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 8L11 8"
        stroke={themeContext.colors.font1}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2 12L8 12"
        stroke={themeContext.colors.font1}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default Icon;
